import React, { useRef } from "react";
import CloseIcon from '@mui/icons-material/Close';
import useModalClose from "../../hooks/useModalClose.js";
import "../editModal/editModal.scss"

const EditModal = ({ title, children, isLoading, onClose, onSave}) => {
    const containerRef = useRef(null);

    useModalClose(containerRef, onClose);

    if (isLoading) return null;

    return (
        <div className="modal" ref={containerRef}>
            <div className="topBar">
                <h5>{title}</h5>
                <button className="closeBtn" onClick={onClose}>
                    <CloseIcon />
                </button>
            </div>

            <form
                onSubmit={(e) => {
                    e.preventDefault();
                    onSave();
                }}
            >
                {children}
            </form>
        </div>
    );
};

export default EditModal